import { useIsMobile } from '@talos/kyoko';
import { useFeatureFlag } from './useFeatureFlag';

export function useIsMobileLayout(): boolean {
  const { enableMobileLayout } = useFeatureFlag();
  const isMobile = useIsMobile();
  return enableMobileLayout && isMobile;
}
